export default class {
    constructor(player) {
        this.player = player;
    }

    // Handle events from /embed/'s parent page
    messageHandler(event) {
        var command;

        // Ignore ad messages
        if (!event.data.command) {
            return;
        }

        command = event.data.command;

        switch (command) {

        case 'playinview':
            if (this.player.getState() === 'paused' && this.player.wasInView) {
                return false;
            }
            this.player.wasInView = true;
            return this.player.play(true);
        case 'play':
            return this.player.play(true);
        case 'pause':
            return this.player.play(false);
        case 'mute':
            return this.player.setMute(true);
        case 'unmute':
            return this.player.setMute(false);
        default:
            return this.player;
        }
    }

    // Set Listeners
    on() {
        window.addEventListener('message', this.messageHandler.bind(this));
    }
}
